import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { SITE_URL } from "@opensea/utils";
import { getProfileUrl, profileUrlFragment } from "@/components/account/utils";
import { JsonLD } from "./JsonLD";
export const ProfileJsonLdFragment = graphql(`
    fragment ProfileJsonLd on Profile {
      displayName
      address
      imageUrl
      bio
      externalUrl
      twitterUsername
      instagramUsername
      ...profileUrl
    }
  `, [profileUrlFragment]);
export const ProfileJsonLD = t0 => {
  const $ = _c(22);
  const {
    profile: key
  } = t0;
  let profile;
  let sameAsLinks;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== key) {
    profile = readFragment(ProfileJsonLdFragment, key);
    sameAsLinks = [];
    if (profile.twitterUsername) {
      sameAsLinks.push(`https://twitter.com/${profile.twitterUsername}`);
    }
    if (profile.instagramUsername) {
      sameAsLinks.push(`https://instagram.com/${profile.instagramUsername}`);
    }
    if (profile.externalUrl) {
      sameAsLinks.push(profile.externalUrl);
    }
    t3 = "Person";
    t4 = profile.displayName || profile.address;
    t5 = profile.imageUrl ?? undefined;
    t6 = profile.bio ?? undefined;
    t1 = SITE_URL.origin;
    t2 = getProfileUrl(profile);
    $[0] = key;
    $[1] = profile;
    $[2] = sameAsLinks;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    profile = $[1];
    sameAsLinks = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  const t7 = `${t1}${t2}`;
  let t8;
  if ($[9] !== sameAsLinks) {
    t8 = sameAsLinks.length > 0 && {
      sameAs: sameAsLinks
    };
    $[9] = sameAsLinks;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = {
      "@type": t3,
      name: t4,
      image: t5,
      description: t6,
      url: t7,
      ...t8
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const mainEntity = t9;
  const t10 = profile.displayName || profile.address;
  const t11 = profile.imageUrl ?? undefined;
  let t12;
  if ($[18] !== mainEntity || $[19] !== t10 || $[20] !== t11) {
    t12 = <JsonLD data={{
      "@context": "https://schema.org",
      "@type": "ProfilePage",
      name: t10,
      image: t11,
      mainEntity
    }} />;
    $[18] = mainEntity;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};